<ngx-page-container>

  <h1>Offer List</h1>
  <hr>
  <div class="scrollable">
    <div class="space">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
      ></ng2-smart-table>
    </div>
  </div>
  <!--<a [routerLink] (click)="downloadXlsx()">Generate XLSX</a>-->
  <br>
  <a [routerLink]="[]" (click)="downloadXlsx()">Generate XLSX</a>

</ngx-page-container>
